(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire07df"];
var parcelRegister = parcelRequire.register;
parcelRegister("9tnsc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41a6c7ecc8ff7cf9$export$2e2bcd8739ae039; });

var $lwczO = parcelRequire("lwczO");
parcelRequire("gaoAP");
var $dfzZn = parcelRequire("dfzZn");

var $7FWw7 = parcelRequire("7FWw7");
var $iN4ie = parcelRequire("iN4ie");
var $9nXWu = parcelRequire("9nXWu");

var $cmhQG = parcelRequire("cmhQG");

var $bhLWo = parcelRequire("bhLWo");





const $41a6c7ecc8ff7cf9$var$loadAdapters = async (context)=>{
    var _context_plugin;
    const plugins = (context === null || context === void 0 ? void 0 : (_context_plugin = context.plugin) === null || _context_plugin === void 0 ? void 0 : _context_plugin.split(",")) || [];
    const data = "default"; // Test CI, remove this later
    (0, $lwczO.default).debug("Adapter Context", context);
    const snowplow = await (0, $dfzZn.default)(context);
    // Apply extensions to the tracker
    const tracker = (0, $7FWw7.applyExtensions)(snowplow, [
        (0, $iN4ie.default),
        (0, $cmhQG.default),
        (0, $bhLWo.default),
        (0, $9nXWu.default),
        /** Dynamically add Google Ads plugin/extension */ plugins.includes("googleAds") && await Promise.resolve((parcelRequire("7FWw7"))).then(({ withGoogleAdsExtension: withGoogleAdsExtension })=>withGoogleAdsExtension),
        /** Dynamically add Bing Ads plugin/extension */ plugins.includes("bingAds") && await Promise.resolve((parcelRequire("7FWw7"))).then(({ withBingAdsExtension: withBingAdsExtension })=>withBingAdsExtension)
    ]);
    window.trackTrans = tracker.ecommerce.trackTransaction;
    window.trackSignUp = tracker.trackSignup;
    window.addToCart = tracker.ecommerce.trackAddToCart;
    window.removeFromCart = tracker.ecommerce.trackRemoveFromCart;
    switch(context.event){
        case "transaction":
            (parcelRequire("gjtns")).then(({ default: load })=>load(tracker));
            break;
        case "impression":
            (parcelRequire("jV2KE")).then(({ default: load })=>load(tracker));
            break;
        case "signup":
            tracker.trackSignup(context);
            break;
        default:
            if (!context.environment) {
                (0, $lwczO.default).warn("No event/environment specified, Only pageview is active");
                return;
            }
            (parcelRequire("gjtns")).then(({ default: load })=>load(tracker));
            (0, $lwczO.default).warn(`No event specified, Loading ${context.environment}`);
    }
};
var $41a6c7ecc8ff7cf9$export$2e2bcd8739ae039 = $41a6c7ecc8ff7cf9$var$loadAdapters;

});
parcelRegister("gaoAP", function(module, exports) {

$parcel$export(module.exports, "createSnowplowTracker", function () { return (parcelRequire("dfzZn")).default; });
parcelRequire("l2W8L");

var $dfzZn = parcelRequire("dfzZn");

});
parcelRegister("l2W8L", function(module, exports) {

var $hkXx1 = parcelRequire("hkXx1");

});
parcelRegister("hkXx1", function(module, exports) {

});


parcelRegister("dfzZn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71b2d7d1db8aa308$export$2e2bcd8739ae039; });

var $lwczO = parcelRequire("lwczO");


const $71b2d7d1db8aa308$var$createSnowplowTracker = async (input)=>{
    const { appId: appId, collector: collector, event: event } = input;
    (0, $lwczO.default).info(`Creating Snowplow tracker for version ${input.version}`);
    const isLegacyTracker = input.version === "1";
    const createSnowplowV1Tracker = async ()=>{
        return await (parcelRequire("exMKC")).then(async ({ default: createSnowplowV1Tracker })=>await createSnowplowV1Tracker(input));
    };
    const createSnowplowV2Tracker = async ()=>{
        return await (parcelRequire("3HWzl")).then(async ({ default: createSnowplowV2Tracker })=>await createSnowplowV2Tracker(input));
    };
    const tracker = isLegacyTracker ? await createSnowplowV1Tracker() : await createSnowplowV2Tracker();
    tracker.initialize({
        appId: appId,
        collector: collector,
        event: event
    });
    tracker.record(input);
    return tracker;
};
var $71b2d7d1db8aa308$export$2e2bcd8739ae039 = $71b2d7d1db8aa308$var$createSnowplowTracker;

});
parcelRegister("exMKC", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("32qsa")).then(()=>parcelRequire("a7EfY"));

});

parcelRegister("3HWzl", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("dqqna")).then(()=>parcelRequire("dFSGc"));

});



parcelRegister("7FWw7", function(module, exports) {

$parcel$export(module.exports, "applyExtensions", function () { return $3c9a89d8c1dfcb00$export$3ad3a750c394cfe6; });
$parcel$export(module.exports, "withSnowplowSegmentsExtension", function () { return (parcelRequire("9nXWu")).default; });
$parcel$export(module.exports, "withGoogleAdsExtension", function () { return (parcelRequire("2JcTW")).default; });
$parcel$export(module.exports, "withBingAdsExtension", function () { return (parcelRequire("iKE1G")).default; });
$parcel$export(module.exports, "withDeduplicationExtension", function () { return (parcelRequire("iN4ie")).default; });

var $9nXWu = parcelRequire("9nXWu");

var $2JcTW = parcelRequire("2JcTW");

var $iKE1G = parcelRequire("iKE1G");

var $iN4ie = parcelRequire("iN4ie");
const $3c9a89d8c1dfcb00$export$3ad3a750c394cfe6 = (tracker, // Either load a function or undefined for dynamic loading
extensions)=>{
    return extensions.reduce((currentTracker, extension)=>extension ? extension(currentTracker) : currentTracker, tracker);
};

});
parcelRegister("9nXWu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dee74d8dbb686cf7$export$2e2bcd8739ae039; });
parcelRequire("i0MG4");
var $gDuU6 = parcelRequire("gDuU6");
const $dee74d8dbb686cf7$var$setupExtension = (context)=>{
    const liquidm = context.segmentId || context.s1;
    //* If s2.pv or s2.tr is not present, use context.s2 as default
    //* mainly used for legacy purposes
    const nexxen = {
        pageVisitorBeaconId: context["s2.pv"] || context["s2"],
        transactionBeaconId: context["s2.tr"] || context["s2"]
    };
    const dstillery = {
        siteVisitorNC: context["s3.pv"] || context["s3"],
        purchaseNC: context["s3.tr"] || context["s3"]
    };
    const segments = (0, $gDuU6.default)({
        liquidm: //* Accept both segmentId and s1 for legacy purposes
        liquidm,
        nexxen: nexxen,
        dstillery: dstillery
    });
    //* Expose cnnaSegments to the window object for custom integrations to use
    window.cnnaSegments = segments;
    liquidm && segments.liquidm.emit();
    nexxen && segments.nexxen.emit();
    dstillery && segments.dstillery.emit();
    return segments;
};
/**
 * This extension will send transaction events to our partner segments when a transaction is tracked
 */ const $dee74d8dbb686cf7$var$withSnowplowSegmentsExtension = (snowplow)=>{
    const segments = $dee74d8dbb686cf7$var$setupExtension(snowplow.context);
    // Original trackTransaction method
    const trackTransaction = snowplow.ecommerce.trackTransaction;
    //* Override the trackTransaction method
    snowplow.ecommerce.trackTransaction = (input)=>{
        trackTransaction(input);
        segments.nexxen.emitPurchase({
            bprice: input.total,
            cid: input.id
        });
        segments.dstillery.emitPurchase({
            amount: input.total,
            orderId: input.id
        });
    };
    return snowplow;
};
var $dee74d8dbb686cf7$export$2e2bcd8739ae039 = $dee74d8dbb686cf7$var$withSnowplowSegmentsExtension;

});
parcelRegister("i0MG4", function(module, exports) {

$parcel$export(module.exports, "createSegments", function () { return (parcelRequire("gDuU6")).default; });

var $gDuU6 = parcelRequire("gDuU6");
parcelRequire("cdX3u");

});
parcelRegister("gDuU6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $641eec616192426d$export$2e2bcd8739ae039; });

var $kcTRk = parcelRequire("kcTRk");

var $8MHlY = parcelRequire("8MHlY");

var $brv19 = parcelRequire("brv19");
const $641eec616192426d$var$createSegments = (input)=>{
    const { liquidm: liquidm, nexxen: nexxen, dstillery: dstillery } = input;
    return {
        nexxen: (0, $8MHlY.default)(nexxen),
        liquidm: (0, $kcTRk.default)(liquidm),
        dstillery: (0, $brv19.default)(dstillery)
    };
};
var $641eec616192426d$export$2e2bcd8739ae039 = $641eec616192426d$var$createSegments;

});
parcelRegister("kcTRk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c72892d13a5cb6a6$export$2e2bcd8739ae039; });

var $lwczO = parcelRequire("lwczO");
const $c72892d13a5cb6a6$var$liquidmSegmentBuilder = (segmentId)=>{
    return {
        emit: ()=>{
            (0, $lwczO.default).info("Building s1 segment with segmentId: ", segmentId);
            (function(c, d) {
                var a = document.createElement("script");
                a.type = "text/javascript";
                a.async = !0;
                a.src = `https://tracking.lqm.io/odin/handle_sync.js?seg=${segmentId}&gdpr=` + ("1" === c ? "1" : "0") + "&gdpr_consent=" + (d ? encodeURIComponent(d) : "") + "&cb=" + new Date().getTime();
                var b = document.getElementsByTagName("script")[0];
                b.parentNode.insertBefore(a, b);
            })();
        }
    };
};
var $c72892d13a5cb6a6$export$2e2bcd8739ae039 = $c72892d13a5cb6a6$var$liquidmSegmentBuilder;

});

parcelRegister("8MHlY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9484abfa4e647eb$export$2e2bcd8739ae039; });

var $lwczO = parcelRequire("lwczO");

var $2FQv2 = parcelRequire("2FQv2");
const $a9484abfa4e647eb$var$nexxenSegmentBuilder = (beacons)=>{
    const { pageVisitorBeaconId: pageVisitorBeaconId, transactionBeaconId: transactionBeaconId } = beacons;
    return {
        emit: ()=>{
            if (!pageVisitorBeaconId) return;
            (0, $lwczO.default).info("Building s2 segment with segmentId: ", pageVisitorBeaconId);
            const pix = (0, $2FQv2.default)(`https://r.turn.com/r/beacon?b2=${pageVisitorBeaconId}`);
            document.head.appendChild(pix);
        },
        emitPurchase: (input)=>{
            const { cid: cid, bprice: bprice } = input;
            if (!cid || !bprice || !transactionBeaconId) {
                (0, $lwczO.default).warn("Missing required data for s2.tr");
                return;
            }
            (0, $lwczO.default).info("Emitting purchase event for segmentId: ", transactionBeaconId);
            const pix = (0, $2FQv2.default)(`https://r.turn.com/r/beacon?b2=${transactionBeaconId}&cid=${cid}&bprice=${bprice}`);
            document.head.appendChild(pix);
        }
    };
};
var $a9484abfa4e647eb$export$2e2bcd8739ae039 = $a9484abfa4e647eb$var$nexxenSegmentBuilder;

});
parcelRegister("2FQv2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7320f870626fdaba$export$2e2bcd8739ae039; });
const $7320f870626fdaba$var$createImagePixel = (url)=>{
    const pixel = document.createElement("img");
    pixel.src = url;
    // Ensure it's 1x1 pixel in size
    pixel.width = 1;
    pixel.height = 1;
    // Make it invisible
    pixel.style.position = "absolute";
    pixel.style.left = "-9999px";
    return pixel;
};
var $7320f870626fdaba$export$2e2bcd8739ae039 = $7320f870626fdaba$var$createImagePixel;

});


parcelRegister("brv19", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0eda113f7e844bf$export$2e2bcd8739ae039; });

var $lwczO = parcelRequire("lwczO");

var $2FQv2 = parcelRequire("2FQv2");
const $c0eda113f7e844bf$var$DstillerySegmentBuilderInput = (input)=>{
    const { siteVisitorNC: siteVisitorNC, purchaseNC: purchaseNC } = input;
    return {
        emit: ()=>{
            if (!siteVisitorNC) return;
            (0, $lwczO.default).info("Building s3 segment with segmentId: ", siteVisitorNC);
            const pix = (0, $2FQv2.default)(`https://action.dstillery.com/orbserv/nsjs?adv=cl172365597545365&ns=8779&nc=${siteVisitorNC}&ncv=76`);
            document.head.appendChild(pix);
        },
        emitPurchase: (input)=>{
            const { orderId: orderId, amount: amount } = input;
            if (!orderId || !amount || !purchaseNC) {
                (0, $lwczO.default).warn("Missing required data for s3.tr");
                return;
            }
            (0, $lwczO.default).info("Emitting dstillery purchase event for segmentId: ", purchaseNC);
            const pix = (0, $2FQv2.default)(`https://action.dstillery.com/orbserv/nsjs?adv=cl172365597545365&ns=8779&nc=${purchaseNC}&ncv=76&dstOrderId=${orderId}&dstOrderAmount=${amount}`);
            document.head.appendChild(pix);
        }
    };
};
var $c0eda113f7e844bf$export$2e2bcd8739ae039 = $c0eda113f7e844bf$var$DstillerySegmentBuilderInput;

});


parcelRegister("cdX3u", function(module, exports) {

});



parcelRegister("2JcTW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e28752228a952a06$export$2e2bcd8739ae039; });

var $lwczO = parcelRequire("lwczO");
const $e28752228a952a06$var$setupExtension = (context)=>{
    // Fail fast if the required params are not present
    if (!context.conversionId || !context.conversionLabel) (0, $lwczO.default).warn("Conversion ID and Conversion Label are required for Google Ads");
    if (!context.conversionId.includes("AW-")) context.conversionId = `AW-${context.conversionId}`;
    (0, $lwczO.default).info(`\u{1F680}\u{1F680}\u{1F680} Google Ads Plugin loaded for ${context.environment}`);
    document.createElement("script").src = `https://www.googletagmanager.com/gtag/js?id=${context.conversionId}`;
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    /**Note: the @ts-ignore lines below are necessary to supress typescript warnings for the arguments object above */ // @ts-ignore
    gtag("js", new Date());
    // @ts-ignore
    gtag("config", context.conversionId);
    // Cross domain tracking
    if (context.crossDomainSites) {
        const crossDomainSites = context.crossDomainSites.split(",");
        const sites = crossDomainSites.map((site)=>site.trim());
        // @ts-ignore
        gtag("set", "linker", {
            domains: sites
        });
    }
};
/**
 * This extension will send Google ads conversion events when a transaction is tracked
 */ const $e28752228a952a06$var$withSnowplowGoogleAdsExtension = (snowplow)=>{
    let { conversionId: conversionId, conversionLabel: conversionLabel } = snowplow.context;
    if (!conversionId.includes("AW-")) conversionId = `AW-${conversionId}`;
    $e28752228a952a06$var$setupExtension(snowplow.context);
    // Original trackTransaction method
    const trackTransaction = snowplow.ecommerce.trackTransaction;
    //* Override the trackTransaction method
    snowplow.ecommerce.trackTransaction = (input)=>{
        trackTransaction(input);
        (0, $lwczO.default).info(`\u{1F680}\u{1F680}\u{1F680} Google Ads Extension Transaction Event`, {
            send_to: `${conversionId}/${conversionLabel}`,
            value: input.total,
            currency: input.currency,
            transaction_id: input.id
        });
        window.gtag("event", "conversion", {
            send_to: `${conversionId}/${conversionLabel}`,
            value: input.total,
            currency: input.currency,
            transaction_id: input.id
        });
    };
    return snowplow;
};
var $e28752228a952a06$export$2e2bcd8739ae039 = $e28752228a952a06$var$withSnowplowGoogleAdsExtension;

});

parcelRegister("iKE1G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7d4fe9e37bf4000$export$2e2bcd8739ae039; });

var $lwczO = parcelRequire("lwczO");
const $b7d4fe9e37bf4000$var$setupExtension = (context)=>{
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.innerHTML = `(function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:${context.tagId}};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");`;
    document.head.appendChild(script);
    window.uetq = window.uetq || [];
};
/**
 * This extension will send Bing Ads conversion events when a transaction is tracked
 */ const $b7d4fe9e37bf4000$var$withSnowplowBingAdsExtension = (snowplow)=>{
    $b7d4fe9e37bf4000$var$setupExtension(snowplow.context);
    // Original trackTransaction method
    const trackTransaction = snowplow.ecommerce.trackTransaction;
    //* Override the trackTransaction method
    snowplow.ecommerce.trackTransaction = (input)=>{
        trackTransaction(input);
        (0, $lwczO.default).info(`\u{1F680}\u{1F680}\u{1F680} Bing Ads Extension Transaction Event`, {
            transaction_id: input.id,
            ecomm_prodid: input.items.map((item)=>item.sku),
            ecomm_pagetype: "purchase",
            ecomm_totalvalue: input.total,
            revenue_value: input.total,
            currency: "USD",
            items: input.items.map((item)=>({
                    id: item.sku,
                    quantity: item.quantity,
                    price: item.unitPrice
                }))
        });
        window.uetq.push("event", "purchase", {
            transaction_id: input.id,
            ecomm_prodid: input.items.map((item)=>item.sku),
            ecomm_pagetype: "purchase",
            ecomm_totalvalue: input.total,
            revenue_value: input.total,
            currency: "USD",
            items: input.items.map((item)=>({
                    id: item.sku,
                    quantity: item.quantity,
                    price: item.unitPrice
                }))
        });
    };
    return snowplow;
};
var $b7d4fe9e37bf4000$export$2e2bcd8739ae039 = $b7d4fe9e37bf4000$var$withSnowplowBingAdsExtension;

});

parcelRegister("iN4ie", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2698e4ae6f73631d$export$2e2bcd8739ae039; });

var $lwczO = parcelRequire("lwczO");
// add a check to check if the jsonString is an array
function $2698e4ae6f73631d$var$tryParseJSONObject(jsonString) {
    try {
        var o = JSON.parse(jsonString);
        if (o && typeof o === "object") return {
            type: "object",
            value: o
        };
        if (Array.isArray(o)) return {
            type: "array",
            value: o
        };
        return {
            type: "string",
            value: jsonString
        };
    } catch (e) {
        return {
            type: "string",
            value: jsonString
        };
    }
}
const $2698e4ae6f73631d$var$withDeduplicationExtension = (snowplow)=>{
    const logger = (0, $lwczO.createLogger)("MJ:Deduplication");
    const { trackTransaction: originalTrackTransaction, trackAddToCart: originalTrackAddToCart, trackRemoveFromCart: originalTrackRemoveFromCart } = snowplow.ecommerce;
    const { trackSignup: originalTrackSignup } = snowplow;
    const getStorageKey = (eventType)=>`${snowplow.context.appId}_${eventType}`;
    const deduplicateEvent = (originalMethod, eventType, input, idField)=>{
        const storageKey = getStorageKey(eventType);
        const eventId = idField.map((key)=>input[key]).join(":");
        let value = localStorage.getItem(storageKey);
        let existingIds = [];
        if (value) {
            const parsed = $2698e4ae6f73631d$var$tryParseJSONObject(value);
            if ((parsed === null || parsed === void 0 ? void 0 : parsed.type) === "object") existingIds = parsed.value;
            else if ((parsed === null || parsed === void 0 ? void 0 : parsed.type) === "string") existingIds = [
                parsed.value
            ];
        }
        logger.debug("existingIds", existingIds);
        if (existingIds.includes(eventId)) {
            logger.warn(`${eventType} with id ${eventId} already tracked. Discarding duplicate.`);
            return;
        }
        originalMethod(input);
        localStorage.setItem(storageKey, JSON.stringify([
            ...existingIds,
            eventId
        ]));
    };
    snowplow.ecommerce.trackTransaction = (input)=>deduplicateEvent(originalTrackTransaction, "transaction", input, [
            "id"
        ]);
    snowplow.ecommerce.trackAddToCart = (input)=>deduplicateEvent(originalTrackAddToCart, "addToCart", input, [
            "name",
            "quantity"
        ]);
    snowplow.ecommerce.trackRemoveFromCart = (input)=>deduplicateEvent(originalTrackRemoveFromCart, "removeFromCart", input, [
            "name",
            "quantity"
        ]);
    snowplow.trackSignup = (input)=>deduplicateEvent(originalTrackSignup, "signUp", input, [
            "uuid",
            "emailAddress"
        ]);
    return snowplow;
};
var $2698e4ae6f73631d$export$2e2bcd8739ae039 = $2698e4ae6f73631d$var$withDeduplicationExtension;

});


parcelRegister("cmhQG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b18efba9eb457c03$export$2e2bcd8739ae039; });
/**
 *
 * This extension ensures that the orderId for the basket items is the same as the orderId for the transaction.
 * This is important for Shopify integrations since the orderId for the basket items is the product id and not the order id.
 */ const $b18efba9eb457c03$var$withEnsureBasketItemsOrderId = (snowplow)=>{
    const trackTransaction = snowplow.ecommerce.trackTransaction;
    snowplow.ecommerce.trackTransaction = (input)=>{
        trackTransaction({
            id: input.id,
            affiliateId: input.affiliateId,
            total: input.total,
            tax: input.tax,
            shipping: input.shipping,
            city: input.city,
            state: input.state,
            country: input.country,
            currency: input.currency,
            discount: input.discount,
            couponCode: input.couponCode,
            alternativeTransactionIds: input.alternativeTransactionIds,
            items: input.items.map((item)=>({
                    orderId: input.id,
                    sku: item.sku,
                    name: item.name,
                    category: item.category,
                    unitPrice: item.unitPrice,
                    quantity: item.quantity,
                    currency: item.currency
                }))
        });
    };
    return snowplow;
};
var $b18efba9eb457c03$export$2e2bcd8739ae039 = $b18efba9eb457c03$var$withEnsureBasketItemsOrderId;

});

parcelRegister("bhLWo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71e7d74cb31b3edc$export$2e2bcd8739ae039; });
let $71e7d74cb31b3edc$var$thirdPartyTags = {};
const $71e7d74cb31b3edc$var$registerThirdPartyTags = (input)=>{
    $71e7d74cb31b3edc$var$thirdPartyTags = input;
};
window.registerThirdPartyTags = $71e7d74cb31b3edc$var$registerThirdPartyTags;
const $71e7d74cb31b3edc$var$replaceMacros = (tag, placeholders)=>tag.replace(/{\w+}/g, (match)=>placeholders[match] || match);
const $71e7d74cb31b3edc$var$createElementForTag = (type, tagWithMacros)=>{
    if (type === "script") {
        const script = document.createElement("script");
        script.src = tagWithMacros;
        script.async = true;
        document.body.appendChild(script);
    } else if (type === "image") {
        const img = new Image();
        img.src = tagWithMacros;
        document.body.appendChild(img);
    }
};
const $71e7d74cb31b3edc$var$processTags = (tags, placeholders)=>{
    tags === null || tags === void 0 ? void 0 : tags.forEach(({ tag: tag, type: type })=>{
        const tagWithMacros = $71e7d74cb31b3edc$var$replaceMacros(tag, placeholders);
        $71e7d74cb31b3edc$var$createElementForTag(type, tagWithMacros);
    });
};
const $71e7d74cb31b3edc$var$withRegisterThirdPartyTagsExtension = (snowplow)=>{
    const { trackTransaction: trackTransaction, trackAddToCart: trackAddToCart, trackRemoveFromCart: trackRemoveFromCart } = snowplow.ecommerce;
    const { trackSignup: trackSignup } = snowplow;
    snowplow.ecommerce.trackTransaction = (input)=>{
        var _input_id, _input_total, _input_tax, _input_shipping, _input_userId;
        trackTransaction(input);
        $71e7d74cb31b3edc$var$processTags($71e7d74cb31b3edc$var$thirdPartyTags.onTransaction, {
            "{transaction_id}": (input === null || input === void 0 ? void 0 : (_input_id = input.id) === null || _input_id === void 0 ? void 0 : _input_id.toString()) || "null",
            "{transaction_total}": (input === null || input === void 0 ? void 0 : (_input_total = input.total) === null || _input_total === void 0 ? void 0 : _input_total.toString()) || "0",
            "{transaction_tax}": (input === null || input === void 0 ? void 0 : (_input_tax = input.tax) === null || _input_tax === void 0 ? void 0 : _input_tax.toString()) || "0",
            "{transaction_shipping}": (input === null || input === void 0 ? void 0 : (_input_shipping = input.shipping) === null || _input_shipping === void 0 ? void 0 : _input_shipping.toString()) || "0",
            "{transaction_city}": (input === null || input === void 0 ? void 0 : input.city) || "null",
            "{transaction_state}": (input === null || input === void 0 ? void 0 : input.state) || "null",
            "{transaction_country}": (input === null || input === void 0 ? void 0 : input.country) || "null",
            "{transaction_currency}": (input === null || input === void 0 ? void 0 : input.currency) || "null",
            "{transaction_userId}": (input === null || input === void 0 ? void 0 : (_input_userId = input.userId) === null || _input_userId === void 0 ? void 0 : _input_userId.toString()) || "null"
        });
    };
    snowplow.ecommerce.trackAddToCart = (input)=>{
        var _input_unitPrice, _input_quantity, _input_userId;
        trackAddToCart(input);
        $71e7d74cb31b3edc$var$processTags($71e7d74cb31b3edc$var$thirdPartyTags.onAddToCart, {
            "{cart_id}": (input === null || input === void 0 ? void 0 : input.sku) || "null",
            "{cart_name}": (input === null || input === void 0 ? void 0 : input.name) || "null",
            "{cart_category}": (input === null || input === void 0 ? void 0 : input.category) || "null",
            "{cart_unitPrice}": (input === null || input === void 0 ? void 0 : (_input_unitPrice = input.unitPrice) === null || _input_unitPrice === void 0 ? void 0 : _input_unitPrice.toString()) || "0",
            "{cart_quantity}": (input === null || input === void 0 ? void 0 : (_input_quantity = input.quantity) === null || _input_quantity === void 0 ? void 0 : _input_quantity.toString()) || "0",
            "{cart_currency}": (input === null || input === void 0 ? void 0 : input.currency) || "null",
            "{cart_userId}": (input === null || input === void 0 ? void 0 : (_input_userId = input.userId) === null || _input_userId === void 0 ? void 0 : _input_userId.toString()) || "null"
        });
    };
    snowplow.ecommerce.trackRemoveFromCart = (input)=>{
        var _input_unitPrice, _input_quantity, _input_userId;
        trackRemoveFromCart(input);
        $71e7d74cb31b3edc$var$processTags($71e7d74cb31b3edc$var$thirdPartyTags.onRemoveFromCart, {
            "{cart_id}": (input === null || input === void 0 ? void 0 : input.sku) || "null",
            "{cart_name}": (input === null || input === void 0 ? void 0 : input.name) || "null",
            "{cart_category}": (input === null || input === void 0 ? void 0 : input.category) || "null",
            "{cart_unitPrice}": (input === null || input === void 0 ? void 0 : (_input_unitPrice = input.unitPrice) === null || _input_unitPrice === void 0 ? void 0 : _input_unitPrice.toString()) || "0",
            "{cart_quantity}": (input === null || input === void 0 ? void 0 : (_input_quantity = input.quantity) === null || _input_quantity === void 0 ? void 0 : _input_quantity.toString()) || "0",
            "{cart_currency}": (input === null || input === void 0 ? void 0 : input.currency) || "null",
            "{cart_userId}": (input === null || input === void 0 ? void 0 : (_input_userId = input.userId) === null || _input_userId === void 0 ? void 0 : _input_userId.toString()) || "null"
        });
    };
    snowplow.trackSignup = (input)=>{
        trackSignup(input);
        $71e7d74cb31b3edc$var$processTags($71e7d74cb31b3edc$var$thirdPartyTags.onSignup, {
            "{signup_firstName}": (input === null || input === void 0 ? void 0 : input.firstName) || "null",
            "{signup_lastName}": (input === null || input === void 0 ? void 0 : input.lastName) || "null",
            "{signup_uuid}": (input === null || input === void 0 ? void 0 : input.uuid) || "null",
            "{signup_email}": (input === null || input === void 0 ? void 0 : input.emailAddress) || "null",
            "{signup_address}": (input === null || input === void 0 ? void 0 : input.address) || "null",
            "{signup_city}": (input === null || input === void 0 ? void 0 : input.city) || "null",
            "{signup_state}": (input === null || input === void 0 ? void 0 : input.state) || "null",
            "{signup_phone}": (input === null || input === void 0 ? void 0 : input.phoneNumber) || "null",
            "{signup_advertiser}": (input === null || input === void 0 ? void 0 : input.advertiser) || "null"
        });
    };
    return snowplow;
};
var $71e7d74cb31b3edc$export$2e2bcd8739ae039 = $71e7d74cb31b3edc$var$withRegisterThirdPartyTagsExtension;

});

parcelRegister("gjtns", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("9DPLo")).then(()=>parcelRequire("7rUq7"));

});

parcelRegister("jV2KE", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("6x0lw")).then(()=>parcelRequire("54bLn"));

});


})();
//# sourceMappingURL=adapters.dcfc097e.js.map
